// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"573":"f760b8b4dafc3ffc","633":"b9b507606418df29","698":"1bbe3472fce91b42"}[chunkId] + ".js";
};